module.exports = __webpack_public_path__ + "static/img/2.516e98b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/2.png
// module id = Z4dV
// module chunks = 1